export function getFormattedDate(date) {
  return date.getMonth() + 1 + "-" + date.getDate() + "-" + date.getFullYear();
}

export function lastDayOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
